import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import { Box, Typography } from "@mui/material";

export default function NavbarLink({ label, to }) {
  return (
    <Box sx={{ padding: "12px 8px" }}>
      <Link to={to} style={{ textDecoration: "none" }}>
        <Typography
          sx={{
            cursor: "pointer",
            transition: "color 0.3s ease",
            "&:hover": {
              textDecoration: "underline",
              color: "primary.light",
            },
          }}
          color="secondary"
          variant="body1"
        >
          {label}
        </Typography>
      </Link>
    </Box>
  );
}
